export const POST_DEALER = "POST_DEALER";
export const POST_DEALER_SUCCESS = "POST_DEALER_SUCCESS";
export const POST_DEALER_ERROR = "POST_DEALER_ERROR";

export const POST_VALIDATE_EMAIL = "POST_VALIDATE_EMAIL";
export const POST_VALIDATE_EMAIL_SUCCESS = "POST_VALIDATE_EMAIL_SUCCESS";
export const POST_VALIDATE_EMAIL_ERROR = "POST_VALIDATE_EMAIL_ERROR";
